<footer   >
    <div class="row containerFooterWidth100"><div class="copyright ng-binding">© Copyright 2024 Risepoint . All rights reserved</div></div>
</footer>